/**
 * Data attribute applied to DependencyGraph SVGs when OpenChoreo manages zoom
 * behavior (prevents the global override from re-patching the same node).
 */
export const DEPENDENCY_GRAPH_CUSTOM_ZOOM_ATTR = 'data-oc-custom-zoom';
